<template>
  <div id="footer" class="footer-root">
    <div class="container">
      <!-- 顶部独立白色底板切割块矩阵 -->
      <div class="row footer-grid-row">
        <!-- 块 1: 品牌与企业定位白色底板 -->
        <div class="col-xs-12 col-sm-6 col-md-4 footer-col">
          <div class="footer-card-plate">
            <div class="footer-logo">
              <img :src="settings.siteLogoBlack || defaultLogoBlack" alt="官方网站logo">
            </div>
            <h4 class="footer-site-title">{{ settings.siteTitle || '班米电商' }}</h4>
            <p class="footer-desc">
              {{ settings.description || defaultDescription }}
            </p>
          </div>
        </div>

        <!-- 块 2: 产品与子系统导航白色底板 -->
        <div class="col-xs-6 col-sm-6 col-md-2 footer-col">
          <div class="footer-card-plate">
            <h5 class="col-title">产品与子系统</h5>
            <ul class="footer-links-list">
              <li><router-link to="/">平台首页</router-link></li>
              <li><router-link to="/software">子系统列表</router-link></li>
              <li><router-link to="/service">相关特色服务</router-link></li>
              <li><router-link to="/newsinformation">动态与新闻</router-link></li>
            </ul>
          </div>
        </div>

        <!-- 块 3: 关于我们与招募白色底板 -->
        <div class="col-xs-6 col-sm-6 col-md-2 footer-col">
          <div class="footer-card-plate">
            <h5 class="col-title">关于与招募</h5>
            <ul class="footer-links-list">
              <li><router-link to="/companyintroduction">企业概况与文化</router-link></li>
              <li><router-link to="/jobchance">热招岗位机会</router-link></li>
              <li><router-link to="/contactus">商务咨询与合作</router-link></li>
            </ul>
          </div>
        </div>

        <!-- 块 4: 联系方式与热线服务白色底板 -->
        <div class="col-xs-12 col-sm-6 col-md-4 footer-col">
          <div class="footer-card-plate">
            <h5 class="col-title">联系与服务保障</h5>
            <div class="footer-contact-info">
              <div class="hotline-box">
                <span class="glyphicon glyphicon-phone-alt"></span>
                <div>
                  <span class="hotline-number">{{ settings.phone || '400-888-9999' }}</span>
                  <span class="hotline-tag">{{ settings.serviceHours || '7x24小时全天候响应' }}</span>
                </div>
              </div>
              <p class="contact-line">
                <span class="glyphicon glyphicon-envelope"></span>
                <span>服务邮箱：{{ settings.email || 'service@official-website.com' }}</span>
              </p>
              <p class="contact-line">
                <span class="glyphicon glyphicon-map-marker"></span>
                <span>总部地址：{{ settings.address || '浙江省杭州市西湖区科技创新园区 A座 18层' }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部版权与备案条 -->
      <div class="footer-bottom-bar">
        <div class="row">
          <div class="col-xs-12 col-md-6 text-left-md text-center-xs">
            <p class="copyright-text">{{ settings.copyright || '© 2026 官方网站 版权所有' }}</p>
          </div>
          <div class="col-xs-12 col-md-6 text-right-md text-center-xs">
            <p class="icp-text">
              <span v-if="settings.icp">ICP备案号：{{ settings.icp }}</span>
              <span v-else>ICP备案号：浙ICP备20268888号-1</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      defaultLogoBlack: require("@/assets/img/logo_black.png"),
      defaultDescription: "专注于企业级业务子系统、大数据中台治理、三维数字孪生及数字化集成解决方案，驱动企业业务创新与高质效增长。",
      settings: {
        siteTitle: '班米电商',
        description: '',
        siteLogoBlack: '',
        siteLogoWhite: '',
        address: '浙江省杭州市西湖区科技创新园区 A座 18层',
        phone: '400-888-9999',
        email: 'service@official-website.com',
        serviceHours: '7x24小时为您服务',
        icp: '浙ICP备20268888号-1',
        copyright: '© 2026 官方网站 版权所有'
      }
    };
  },
  created() {
    this.fetchSettings();
  },
  methods: {
    async fetchSettings() {
      try {
        const res = await fetch('/api/settings');
        const json = await res.json();
        if (json.code === 200 && json.data) {
          Object.assign(this.settings, json.data);
        }
      } catch (e) {
        try {
          const res2 = await fetch('/api/settings');
          const json2 = await res2.json();
          if (json2.code === 200 && json2.data) {
            Object.assign(this.settings, json2.data);
          }
        } catch (err) {}
      }
    }
  }
};
</script>

<style scoped>
.footer-root {
  width: 100%;
  background: #090f1d;
  color: #94a3b8;
  padding: 50px 0 25px;
  font-size: 13px;
  border-top: 1px solid #162238;
}

.footer-grid-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px;
}

.footer-col {
  margin-bottom: 20px;
  display: flex;
}

/* 内部独立直角硬朗深灰底板卡片 (块切割样式) */
.footer-card-plate {
  background: #c3d0df;
  border: 1px solid #9fb3cb;
  border-radius: 0;
  padding: 24px 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.25);
  transition: all 0.3s ease;
}

.footer-card-plate:hover {
  border-color: #3370FF;
  background: #cbdaf0;
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(51, 112, 255, 0.22);
}

.footer-logo {
  height: 44px;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.footer-logo img {
  height: 100%;
  max-width: 150px;
  object-fit: contain;
  object-position: left center;
  margin-left: 0;
}

.footer-site-title {
  font-size: 14px;
  font-weight: 700;
  color: #091325;
  margin: 0 0 10px;
  line-height: 1.4;
}

.footer-desc {
  color: #1e293b;
  line-height: 1.6;
  font-size: 12px;
  margin: 0;
  flex: 1;
}

.col-title {
  font-size: 15px;
  font-weight: 700;
  color: #091325;
  margin: 0 0 16px;
  position: relative;
  padding-bottom: 8px;
}

.col-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 24px;
  height: 2px;
  background: #1d4ed8;
  border-radius: 0;
}

.footer-links-list {
  list-style: none;
  padding: 0;
  margin: 0;
  flex: 1;
}

.footer-links-list li {
  margin-bottom: 10px;
}

.footer-links-list li a {
  color: #1e293b;
  text-decoration: none;
  transition: all 0.2s ease;
  font-size: 13px;
  font-weight: 500;
  display: inline-block;
}

.footer-links-list li a:hover {
  color: #1d4ed8;
  transform: translateX(4px);
  font-weight: 700;
}

.footer-contact-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
}

.hotline-box {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #a9bed6;
  padding: 10px 14px;
  border-radius: 0;
  border: 1px solid #8ba5c4;
  margin-bottom: 2px;
}

.hotline-box .glyphicon {
  font-size: 18px;
  color: #1d4ed8;
}

.hotline-number {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #0f2963;
  letter-spacing: 0.5px;
}

.hotline-tag {
  display: block;
  font-size: 11px;
  color: #0369a1;
}

.contact-line {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #1e293b;
  margin: 0;
  font-size: 12px;
}

.contact-line .glyphicon {
  color: #1d4ed8;
  font-size: 12px;
}

.footer-bottom-bar {
  border-top: 1px solid #162238;
  padding-top: 22px;
  margin-top: 5px;
}

.copyright-text, .icp-text {
  color: #64748b;
  font-size: 12px;
  margin: 0;
  line-height: 1.8;
}

.text-left-md { text-align: left; }
.text-right-md { text-align: right; }

@media (max-width: 991px) {
  .text-left-md, .text-right-md { text-align: center; }
  .footer-grid-row { display: block; }
  .footer-col { display: block; }
  .col-title::after { left: 0; }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue